// extracted by mini-css-extract-plugin
export const card = "chugli-module--card--3HqCW";
export const outer = "chugli-module--outer--ZQ3MF";
export const containerImage = "chugli-module--container-image--230iF";
export const candidateImage = "chugli-module--candidate-image--fGN7o";
export const topRow = "chugli-module--top-row--jbuKb";
export const bottomRow = "chugli-module--bottom-row--1D5R3";
export const button = "chugli-module--button--25qDt";